import { CelsiusWrapper, FahrenheitWrapper, Icon, DayWrapper } from "./Day.styled";
import { FC } from "react";

interface Props {
  day: {
    date_epoch: number;
    day:{
      maxtemp_c: number;
      mintemp_c: number;
      maxwind_mph: number;
      condition:{
        icon: string;
        text: string;
      }
    }
  }
}

const Day: FC<Props> = ({ day }) => {

  let days = [
    "Sunday",
    "Monday",
    "Tuesday",
    "Wednesday",
    "Thursday",
    "Friday",
    "Saturday",
  ];

  return (
    <DayWrapper>
      {days[new Date(day.date_epoch * 1000).getDay()]}
      <Icon src={day?.day.condition.icon} alt={day?.day.condition.text} />
      <div style={{ display: "flex" }}>
        <FahrenheitWrapper>
          {Math.ceil(day?.day.maxtemp_c)}
          <span>&#8451;</span>
        </FahrenheitWrapper>
        &nbsp;
        <CelsiusWrapper>
          {Math.ceil(day?.day.mintemp_c)}
          <span>&#8451;</span>
        </CelsiusWrapper>
      </div>
      max wind {day?.day.maxwind_mph} mph
    </DayWrapper>
  );
};
export default Day;